import React, { useContext, useEffect } from 'react';
import { SettingsContext } from '../../context/SettingsContext';

const FontLoader = () => {
    const { font } = useContext(SettingsContext);

    useEffect(() => {
        if (!font) return;

        // Convert "Open Sans" -> "Open+Sans"
        const fontName = font.replace(/\s+/g, '+');
        
        const linkId = 'dynamic-font-loader';
        const href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700&display=swap`;

        let link = document.getElementById(linkId);
        if (!link) {
            link = document.createElement('link');
            link.id = linkId;
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }

        link.href = href;
    }, [font]);

    return null;
};

export default FontLoader;